module.exports = __webpack_public_path__ + "static/media/wallet-photos-and-prints.c9b3de1f.webp";